import PropTypes from "prop-types";
import React from "react";

export const Parking2 = (props) => {
  const { className, role, size, style } = props;

  return (
    <svg {...getProps()}>
      <path d="M8.66667 2H4V14H6.66667V10H8.66667C10.8733 10 12.6667 8.20667 12.6667 6C12.6667 3.79333 10.8733 2 8.66667 2ZM8.8 7.33333H6.66667V4.66667H8.8C9.53333 4.66667 10.1333 5.26667 10.1333 6C10.1333 6.73333 9.53333 7.33333 8.8 7.33333Z" />
    </svg>
  );

  function getProps() {
    return {
      "aria-label": props["aria-label"],
      className,
      height: size,
      role,
      strokeWidth: "0",
      style,
      viewBox: "0 0 15 15",
    };
  }
};

Parking2.displayName = "Parking2Icon";

Parking2.propTypes = {
  /** aria-label text to provide accessibility description for this SVG element. */
  "aria-label": PropTypes.string,

  /**
   * Additional classes for positioning the component. Given classes may only position this component for layout
   * purposes, and cannot change how the component renders in any way.
   */
  className: PropTypes.string,

  /** Name used for aria role. */
  role: PropTypes.string,

  /** Indicates icon's height. The width will be sized accordion to SVG's aspect ratio. */
  size: PropTypes.string,

  /**
   * CSS object to applied to SVG element. Currently, style is expected to only define stroke and fill color, but
   * there is not such a restriction or requirement at this time.
   */
  style: PropTypes.object,
};

Parking2.defaultProps = { role: "img" };
